import React, { useState, useEffect } from 'react';
import './files-rejection.css';

const FilesRejectionMain = (props) => {
  const [files, setFiles] = useState([]);

  const fileSize = (size) => {
    const pow = Math.pow(10, 2);
    return !!Math.round(size / 1000000)
      ? `${Math.abs(Math.round((size / 1000000) * pow) / pow)}MB`
      : `${Math.abs(Math.round((size / 1000) * pow) / pow)}KB`;
  };

  const bytesToMegabytes = (bytes) => {
    const megabytes = bytes / (1024 * 1024);
    return parseFloat(megabytes.toFixed(1)) % 1 === 0 ? megabytes.toFixed(0) : megabytes.toFixed(1);
  };

  useEffect(() => {
    const files = props.rejectedFiles
      ? props.rejectedFiles.map(({ file }) => ({
          name: file.name,
          size: fileSize(file.size),
        }))
      : [];
    setFiles(files);
  }, [props.rejectedFiles]);

  useEffect(() => {
    props.onUpdateModifiers && props.onUpdateModifiers({ add: ['default'] });
  }, []);

  return (
    <div className='files-rejection'>
      <h1 className='files-rejection__title'>Datei zu groß</h1>
      <ul className='files-rejection__list'>
        {files.map((file) => (
          <li key={file.name}>
            <div>
              <i>{file.name}</i> - {file.size}
            </div>
          </li>
        ))}
      </ul>
      <p>überschreitet die maximale Dateigröße von {bytesToMegabytes(props.size)} MB.</p>
      <p>Wählen Sie bitte eine kleinere Datei aus.</p>
    </div>
  );
};

FilesRejectionMain.displayName = 'FilesRejectionMain';

export default FilesRejectionMain;
